module.exports = __webpack_public_path__ + "static/ISBAO-5eb7df04117a4845fcac052227c033e7.png";